var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgUserAssignmentIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 6.3a2.243 2.243 0 0 0 2.241-2.25c0-1.242-.999-2.25-2.241-2.25a2.25 2.25 0 0 0 0 4.5ZM6.3 5.4a2.689 2.689 0 0 0 2.691-2.7C8.991 1.206 7.794 0 6.3 0a2.696 2.696 0 0 0-2.7 2.7c0 1.494 1.206 2.7 2.7 2.7Zm6.75 2.7c-1.647 0-4.95.828-4.95 2.475V11.7c0 .495.405.9.9.9h8.1c.495 0 .9-.405.9-.9v-1.125C18 8.928 14.697 8.1 13.05 8.1ZM6.3 7.2C4.203 7.2 0 8.253 0 10.35v1.35c0 .495.405.9.9.9h5.4v-2.025c0-.765.297-2.106 2.133-3.123C7.65 7.29 6.894 7.2 6.3 7.2Z",
    fill: "#fff"
  })));
};
export { SvgUserAssignmentIcon as ReactComponent };
export default __webpack_public_path__ + "521e232d91ef9f3e37ffbd37dbcd234c.svg";